// LIBRARIES
import Vue from 'vue'
import '@babel/polyfill'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@fortawesome/fontawesome-free/css/all.css'

// FILES
import './plugins/axios'
import App      from './App.vue'
import router   from './router'
import store    from './store'
import vuetify  from './plugins/vuetify';

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
  created(){
    store.dispatch('getGroupResources')
    store.dispatch('getSubmitted')
    store.dispatch('getSettings')
  }
}).$mount('#app')
